var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgInactivesphereresized(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 230,
    height: 229,
    viewBox: "0 0 230 229",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    opacity: 0.5,
    filter: "url(#filter0_d_3403_29489)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_3403_29489)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 79,
    y: 75,
    width: 72,
    height: 72,
    rx: 36,
    fill: "white"
  }), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter1_f_3403_29489)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    cx: 132.998,
    cy: 118.649,
    rx: 30.6,
    ry: 28.35,
    fill: "#636980"
  })), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter2_f_3403_29489)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    cx: 103.745,
    cy: 122.249,
    rx: 31.05,
    ry: 31.95,
    fill: "#E3E8FC"
  })), /*#__PURE__*/React.createElement("g", {
    opacity: 0.78,
    filter: "url(#filter3_f_3403_29489)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    cx: 115.455,
    cy: 101.1,
    rx: 39.15,
    ry: 36,
    fill: "#2D53DA"
  }))), /*#__PURE__*/React.createElement("rect", {
    x: 79.2455,
    y: 75.2455,
    width: 71.5091,
    height: 71.5091,
    rx: 35.7545,
    stroke: "#2D53DA",
    strokeWidth: 0.490909
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_3403_29489",
    x: 0.945457,
    y: 0.545458,
    width: 228.109,
    height: 228.109,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feMorphology", {
    radius: 20.2909,
    operator: "dilate",
    in: "SourceAlpha",
    result: "effect1_dropShadow_3403_29489"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 3.6
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 28.8818
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.176471 0 0 0 0 0.32549 0 0 0 0 0.854902 0 0 0 0.83 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_3403_29489"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_3403_29489",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter1_f_3403_29489",
    x: 76.2984,
    y: 64.1988,
    width: 113.403,
    height: 108.899,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 13.05,
    result: "effect1_foregroundBlur_3403_29489"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter2_f_3403_29489",
    x: 46.5953,
    y: 64.1988,
    width: 114.302,
    height: 116.1,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 13.05,
    result: "effect1_foregroundBlur_3403_29489"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter3_f_3403_29489",
    x: 48.5683,
    y: 37.3632,
    width: 133.77,
    height: 127.473,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 13.8682,
    result: "effect1_foregroundBlur_3403_29489"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_3403_29489"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 79,
    y: 75,
    width: 72,
    height: 72,
    rx: 36,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInactivesphereresized);
export default __webpack_public_path__ + "static/media/Inactive sphere resized.053f4bebeac61c8eb7d1478acdbd47c0.svg";
export { ForwardRef as ReactComponent };